var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotspotEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12865 13.9247L14.6992 6.35417C15.1715 5.88201 15.9374 5.88188 16.4096 6.35417L17.6555 7.60023C18.1278 8.07259 18.1278 8.83843 17.6555 9.31078L10.085 16.8813C9.95221 17.0141 9.79036 17.1141 9.61223 17.1735L7.28621 17.9489C6.52907 18.2013 5.80876 17.481 6.06114 16.7238L6.83648 14.3975C6.89586 14.2193 6.99589 14.0575 7.12865 13.9247ZM13.9227 8.15898L15.8501 10.0865L9.57049 16.3668C9.51759 16.4197 9.45311 16.4596 9.38215 16.4832L7.05613 17.2586C6.86778 17.3214 6.6886 17.1422 6.75138 16.9539L7.52672 14.6276C7.55038 14.5566 7.59023 14.4921 7.64312 14.4392L13.9227 8.15898ZM17.1411 8.79625L16.3613 9.57551L14.4339 7.64795L15.2137 6.86869C15.4019 6.6805 15.707 6.6805 15.8951 6.86869L17.1411 8.11476C17.3292 8.30295 17.3292 8.60806 17.1411 8.79625Z",
    fill: "#202123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspotEditIcon);
export default __webpack_public_path__ + "static/media/hotspotEditIcon.ba945ea496ea417bbba23cfcf0886278.svg";
export { ForwardRef as ReactComponent };